import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { REFUND_DAYS } from "../../config/subscription.js";
import "./duvidas_list.css";

function DuvidasList() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqData = [
        {
            question: "A quem se destinam os cursos do site?",
            answer: "Todo o conteúdo do site foi pensado para alunos de cursos de engenharia, que costumam ter disciplinas de circuitos elétricos. No entanto, todos que quiserem aprender circuitos neste nível são bem-vindos, desde que saibam do direcionamento."
        },
        {
            question: "Quanto de matemática é necessário saber para fazer os cursos?",
            answer: "É recomendado ter uma base boa de matemática de ensino fundamental e médio, em especial saber fazer contas básicas, geometria básica, resolver equações simples, sistemas de equações lineares e números complexos. Noções de cálculo diferencial e integral são úteis em alguns módulos mais avançados, mas se você não souber, ainda consegue aprender a maior parte do curso."
        },
        {
            question: "O que o Domínio Elétrico não ensina?",
            answer: "Nenhum curso do site ensina a reparar aparelhos elétricos ou eletrônicos. Por isso dizemos que os conteúdos são voltados para o contexto de cursos de engenharia."
        },
        {
            question: "O Domínio Elétrico fornece certificado de conclusão?",
            answer: "Sim, mas depende de concluir as aulas e passar numa prova (que não é fácil). De centenas de alunos, pouquíssimos conseguiram certificado até hoje. Valorizamos a seriedade do nosso ensino. Aqui não é estilo 'pagou-passou'. Se estiver em busca de um certificado fácil, o Domínio Elétrico não vale a pena. Mas se quiser dominar os circuitos, aqui é o lugar certo."
        },
        {
            question: "A partir de qual semestre da faculdade vale a pena fazer o curso?",
            answer: "Um aluno com boa formação escolar consegue aproveitar a maior parte do curso mesmo que comece já no primeiro semestre do curso. Apenas alguns módulos mais avançados requerem conceitos básicos de derivadas, integrais e EDOs lineares."
        },
        {
            question: "Por onde começar o curso?",
            answer: "A não ser que já tenha noção de circuitos elétricos, recomendamos seguir a ordem natural do curso, começando pelo módulo de Conceitos Básicos."
        },
        {
            question: "Qual o perfil dos alunos do Domínio Elétrico?",
            answer: "Temos alunos de praticamente todos os estados do Brasil e também de outros países. Há estudantes de escolas técnicas, universidades públicas e privadas, além de profissionais já formados e atuando no mercado."
        },
        {
            question: "E se eu não gostar dos cursos?",
            answer: `Caso o curso não atenda às suas expectativas, você conta com garantia de ${REFUND_DAYS} dias para solicitar o cancelamento e reembolso integral.`
        },
        {
            question: "As faculdades já não ensinam circuitos elétricos?",
            answer: "Em teoria sim. Porém, a realidade mostra que muitos estudantes chegam com dificuldades, principalmente após os anos de ensino remoto. É justamente para preencher essa lacuna que o Domínio Elétrico existe."
        },
        {
            question: "As aulas são teóricas ou práticas?",
            answer: "Temos tanto aulas teóricas quanto práticas (DE Labs). A teoria explica os fenômenos observados, enquanto as práticas permitem visualizar e consolidar o aprendizado."
        },
        {
            question: "Em quanto tempo eu consigo fazer o curso?",
            answer: "Com um ritmo consistente, é possível concluir o conteúdo principal em cerca de um ano. Com mais dedicação, é possível terminar em  seis meses ou menos."
        },
        {
            question: "O curso me ajuda a conseguir uma vaga no mercado de trabalho?",
            answer: "Sim, mas de forma indireta. O curso fortalece seu domínio em circuitos elétricos, melhora seu desempenho na graduação e ajuda a desenvolver conhecimentos que fazem diferença tanto em processos seletivos quanto na atuação profissional."
        }
    ];

    const toggleQuestion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="duvidas-list-section">
            <div className="duvidas-list-container">

                <div className="duvidas-list-header">
                    <h2>Perguntas Frequentes</h2>
                    <p>
                        Tire suas principais dúvidas sobre os cursos, certificados,
                        funcionamento da plataforma e para quem o Domínio Elétrico foi criado.
                    </p>
                </div>

                <div className="faq-list">

                    {faqData.map((item, index) => (
                        <div
                            key={index}
                            className={`faq-item ${openIndex === index ? "active" : ""}`}
                        >

                            <button
                                className="faq-question"
                                onClick={() => toggleQuestion(index)}
                            >

                                <span>{item.question}</span>

                                <ChevronDown
                                    size={22}
                                    className={`faq-icon ${openIndex === index ? "rotate" : ""}`}
                                />

                            </button>

                            <div
                                className={`faq-answer ${
                                    openIndex === index ? "open" : ""
                                }`}
                            >
                                <p>{item.answer}</p>
                            </div>

                        </div>
                    ))}

                </div>

            </div>
        </section>
    );
}

export default DuvidasList;